module.exports = __webpack_public_path__ + "media/images/sample/ic_mcdonald-982e6e3160184481bfd604dcc5d3f1db.png";